// extracted by mini-css-extract-plugin
export var enlargeButton = "schema-image-block-module--enlargeButton--80e27";
export var figcaption = "schema-image-block-module--figcaption--8864e";
export var figure = "schema-image-block-module--figure--a8b59";
export var image = "schema-image-block-module--image--21c28";
export var imageSkinElevated = "schema-image-block-module--imageSkinElevated--84932";